<template>
  <div class="mt55">
    <div
      class="w1200"
      v-show="isShow"
    >
      <div class="head clearfix">
        <HT
          text="gsjj"
          style="margin-top:20px;float:left"
        />
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/gdyy' }">
                关于固德
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/gdyy' }">
                公司简介
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div class="content clearfix pr">
        <div class="left pic fl" />
        <div class="right text fr">
          <p>浙江固德医药有限公司地处浙江温州，建筑面积1万余平方米。按现代物流标准设立的医药批发企业。</p><p>公司以经营药品、中药饮片、医疗器械、食品等为主营业务；以医药专业分销、现代物流、电子商务及终端零售为主要经营业态。</p><p>公司秉承“同创造 共发展 齐分享”的企业理念，致力于给百姓带去健康快乐；给客户和伙伴带来超值利益；给员工提供实现自身价值的平台；给企业创造持续发展的空间。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HT from '@/components/h2.vue'

export default {
    data() {
        return {
            list: [],
            isShow: true
        }
    },
    components: {
        HT
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        padding: 70px 55px;
        display: flex;
        flex-direction: row;
        gap: 100px;
    }
    .content .left.pic{
        width: 395px;
        height: 233px;
        background: url('../../../assets/images/gygd.jpg') center center no-repeat;
    }
    .content .right.text{
        width: 650px;
        top: 50%;
        right: 55px;
        text-indent: 2em;
        font-size: 16px;
        line-height: 26px;
        color: #666;
    }
</style>

<style>
    .head{
        position: relative;
    }
    .bread{
        position: absolute;
        right: 0;
        bottom: 15px;
    }
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>